import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { InnerHero } from '@/components/sections'
import { Prefooter, Footer } from '@/components/layout'

export function RegolamentoPage() {
  const { t } = useTranslation('common')

  const sectionKeys = [
    'regolamento.sections.promotore',
    'regolamento.sections.partecipanti',
    'regolamento.sections.territorio',
    'regolamento.sections.durata',
    'regolamento.sections.destinatari',
    'regolamento.sections.registrazione',
    'regolamento.sections.funzionamento',
    'regolamento.sections.livelli',
    'regolamento.sections.azzeramento',
    'regolamento.sections.modifica',
    'regolamento.sections.contatti',
  ]

  return (
    <main>
      <InnerHero
        eyebrow={t('regolamento.hero.eyebrow')}
        title={t('regolamento.hero.title')}
        titleItalic={t('regolamento.hero.titleItalic')}
        body=""
        breadcrumbs={[
          { label: t('breadcrumbs.home'), href: '/it' },
          { label: t('regolamento.hero.breadcrumb') },
        ]}
      />

      <section className="bg-cream py-20 md:py-28">
        <div className="nashi-container max-w-3xl">
          <div className="space-y-12">
            {sectionKeys.map((key, idx) => (
              <motion.article
                key={key}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.8, delay: idx * 0.05 }}
              >
                <h2 className="font-display text-bruno text-xl md:text-2xl mb-4">
                  {t(`${key}.title`)}
                </h2>
                <p className="text-bruno-soft leading-relaxed text-sm md:text-base whitespace-pre-line">
                  {t(`${key}.content`)}
                </p>
              </motion.article>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="mt-20 pt-10 border-t border-bruno/10"
          >
            <p className="text-[11px] uppercase tracking-[0.24em] text-bruno-muted">
              {t('regolamento.lastUpdate')}
            </p>
          </motion.div>
        </div>
      </section>

      <Prefooter />
      <Footer />
    </main>
  )
}
